import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../../api/apiFactory";
import { showNotification } from "../notificationSlice";

const coursesApi = factory.get("courses");
const initialState = {
  courses: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      skip: 0,
      take: 10,
      search: "",
      company_id: null,
    },
    dialog: false,
  },
  manageCourse: {
    loading: false,
    dialog: false,
    form: {
      id: "",
      name: "",
      description: "",
      duration: "",
      seats_count: 0,
      price: "",
      company_id: null,
      is_active: true,
      apply_link: "",
    },
  },
};

export const coursesSlice = createSlice({
  name: "courses",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setCourses: (state, action) => {
      state.courses.data = action.payload.data;
      state.courses.total = action.payload.total;
    },
    setFilters: (state, { payload }) => {
      state.courses.filters = {
        ...state.courses.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.courses.filters = initialState.courses.filters;
    },
    setFiltersDialog: (state, action) => {
      state.courses.dialog = !state.courses.dialog;
    },
    setDialog: (state, { payload }) => {
      if (payload) {
        state.manageCourse.form = payload;
      } else {
        state.manageCourse.form = initialState.manageCourse.form;
      }
      state.manageCourse.dialog = !state.manageCourse.dialog;
    },
    resetForm: (state, action) => {
      state.manageCourse.form = initialState.manageCourse.form;
    },
  },
});

export const {
  setLoading,
  setCourses,
  setFilters,
  resetFilters,
  setFiltersDialog,
  resetForm,
  setDialog,
} = coursesSlice.actions;

export default coursesSlice.reducer;

const index = () => async (dispatch, getState) => {
  try {
    const filters = getState().courses.courses.filters;
    const _filters = {
      ...filters,
      company_id: filters.company_id?.id || null,
    };
    dispatch(setLoading("courses"));
    const res = await coursesApi.index(_filters);
    dispatch(setCourses(res.data));
    dispatch(setLoading("courses"));
  } catch (err) {
    dispatch(setLoading("courses"));
    console.log(err);
  }
};

const create = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("manageCourse"));
    
    const formData = new FormData();
    
    // Add all form fields to FormData
    for (const key in data) {
      if (key === 'attachment' && data[key]) {
        formData.append('attachment', data[key]);
      } else if (key === 'company_id' && data[key]) {
        const companyIdValue = typeof data[key] === 'object' ? data[key].company_id : data[key];
        formData.append('company_id', companyIdValue);
      } else if (key === 'is_active') {
        // Convert boolean to 1/0
        formData.append('is_active', data[key] ? 1 : 0);
      } else if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key]);
      }
    }
    
    await coursesApi.create(formData);
    dispatch(setLoading("manageCourse"));
    dispatch(
      showNotification({
        type: "success",
        message: "Course Created successfully",
      })
    );

    dispatch(setDialog());
    dispatch(resetForm());
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("manageCourse"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response?.data?.errors?.[0] || "Error creating course",
      })
    );
    console.log(err);
  }
};

const update = (id, data) => async (dispatch) => {
  try {
    dispatch(setLoading("manageCourse"));
    
    let requestData;
    
    if (data.attachment) {
      // Create FormData for file uploads
      const formData = new FormData();
      for (const key in data) {
        if (key === 'attachment' && data[key]) {
          formData.append('attachment', data[key]);
        } else if (key === 'company_id' && data[key]) {
          const companyIdValue = typeof data[key] === 'object' ? data[key].company_id : data[key];
          formData.append('company_id', companyIdValue);
        } else if (key === 'is_active') {
          // Convert boolean to 1/0
          formData.append('is_active', data[key] ? 1 : 0);
        } else if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      }
      requestData = formData;
    } else {
      // Use regular JSON if no file
      const companyId = typeof data.company_id === 'object' ? data.company_id.company_id : data.company_id;
      requestData = {
        ...data,
        company_id: companyId,
        is_active: data.is_active ? 1 : 0, // Convert boolean to 1/0
      };
    }
    
    await coursesApi.update(id, requestData);
    dispatch(setLoading("manageCourse"));
    dispatch(
      showNotification({
        type: "success",
        message: "Course updated successfully",
      })
    );

    dispatch(setDialog());
    dispatch(resetForm());
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("manageCourse"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response?.data?.errors?.[0] || "Error updating course",
      })
    );
    console.log(err);
  }
};

const deleteCourse = (id) => async (dispatch) => {
  try {
    await coursesApi.delete(id);
    dispatch(
      showNotification({
        type: "success",
        message: "Course deleted successfully",
      })
    );
    dispatch(index());
  } catch (err) {
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
    console.log(err);
  }
};

export const Courses = {
  index,
  create,
  update,
  deleteCourse,
}; 